import { ArrowBackIcon } from "@chakra-ui/icons";
import { Box } from "@chakra-ui/react";
import React, { ReactNode } from "react";
import { NavLink } from "react-router";

import { APP_BASE_HREF } from "../App";

interface MyProps {
  imgUrl: string;
  imgAltDescription: string;
  headerText: string;
  explanationText: string | JSX.Element;
  backUrl: string;
  fieldName?: string; // for the animation effect of explain box to work when moving to a new field in form
  children: ReactNode;
}

export const ExplainSideColumn: React.FC<MyProps> = ({
  imgUrl,
  imgAltDescription,
  headerText,
  explanationText,
  backUrl,
  fieldName,
  children,
}) => {
  return (
    <>
      <div style={{ marginBottom: "20px" }}>
        <NavLink to={APP_BASE_HREF + backUrl} style={{ textDecoration: "none" }}>
          <ArrowBackIcon boxSize={5} color="brand.analytic" />
          <Box as="span" color="brand.analytic" style={{ fontWeight: "600", paddingLeft: "5px" }}>
            Back to overview
          </Box>
        </NavLink>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "stretch",
          width: "100%",
        }}
      >
        <Box
          backgroundColor="brand.cloudy"
          borderColor="brand.glacier"
          style={{
            width: "346px",
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            margin: "8px 16px 0 0",
            borderStyle: "solid",
            borderWidth: "0.5px",
            padding: "20px",
            borderRadius: "5px",
            height: "100%",
          }}
        >
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img
              style={{ borderRadius: "4px", width: "100%" }}
              src={imgUrl}
              alt={imgAltDescription ? imgAltDescription : "Left sidebar icon"}
            />
          </div>
          <Box
            as="h2"
            color="brand.deep_sea"
            style={{ marginBottom: "10px", marginTop: "10px", fontSize: "24px" }}
          >
            {headerText}
          </Box>
          <div key={fieldName}>
            <Box as="span" lineHeight="28px" color="brand.deep_sea">
              {explanationText}
            </Box>
          </div>
        </Box>
        <div
          style={{
            flex: 1,
            minWidth: 0,
            overflow: "hidden",
            paddingBottom: "25px",
          }}
        >
          {children}
        </div>
      </div>
    </>
  );
};
